var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"practical-training-course"},[_c('div',{staticClass:"headerWrapper"},[_c('Header')],1),_c('div',{staticClass:"contentWrapper"},[_c('GrayAroundWhiteInMiddle',[_c(_vm.componentName,{tag:"component"})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }